module.exports = "/images/white-0.98.png?fa0acace1c97a1ddc8fe3d64b8de5f79";